__webpack_require__.p = "/InteractiveBooks/";